'use client'
import React, { useEffect, useState } from 'react'
import MyImage from '@shared/components/myImage'
import newspaper from '@assets/images/Advertisement/newspaper.png'
import AdCard from '@shared/components/Advertisement/AdCard/AdCard'
import BettingPartner from '@shared/components/Advertisement/Partner/BettingPartner'
import FantasyPartner from '@shared/components/Advertisement/Partner/FantasyPartner'
import MobileAd from '@shared/components/Advertisement/MobileAd/MobileAd'
import styles from '@shared/components/Advertisement/Advertise.module.scss'

async function fetchIp() {
  try {
    const res = await fetch('https://api.ipify.org?format=json')
    const data = await res.json()
    return data.ip
  } catch (error) {
    throw new Error('Failed to fetch IP')
  }
}

async function fetchIpData(ip) {
  try {
    const res = await fetch(`https://freeipapi.com/api/json/${ip}`)
    const data = await res.json()
    return data.countryCode === 'IN'
  } catch (error) {
    throw new Error('Failed to fetch IP data')
  }
}
const Advertise = () => {
  const [showSection, setShowSection] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      const ip = await fetchIp()
      const show = await fetchIpData(ip)
      setShowSection(show)
    }

    fetchData()
  }, [])

  return (
    <>
      <div className={styles['advertise-container']}>
       {/* left */}
        <div className={styles['advertise-text']}>
          <h1>
            How we <br /> Advertise?
          </h1>
          <p>
          Fastest live scores, detailed commentary,match stats, squad info, and scorecards.
          </p>
        </div>

        <div className={styles['advertise-image']}>

        <MyImage
            src={newspaper}
            alt="Advertisement"

            className ={styles.img}

          />

        </div>
      </div>
      <AdCard />
      {showSection !== null ? (
        <>{showSection ? <FantasyPartner /> : <BettingPartner />}</>
      ) : null}
      <MobileAd />
      </>
  )
}
export default Advertise
